<template>
  <v-app>
     <dashboard-Core-App-Bar />
    <dashboard-core-drawer />
    <dashboard-core-view />
    <dashboard-core-settings />
  </v-app>  
</template>

<script>
export default {
  name: "DashboardIndex",
  components: {
    DashboardCoreAppBar: () => import("./components/assistantTeach/AppBar"),
    DashboardCoreDrawer: () => import("./components/assistantTeach/Drawer"),
    DashboardCoreSettings: () => import("./components/assistantTeach/Settings"),
    DashboardCoreView: () => import("./components/assistantTeach/View"),
  },
  data: () => ({   
    loginuser: JSON.parse(localStorage.getItem('user')) || 0,   
  }),
    mounted() {
      let user = JSON.parse(localStorage.getItem('user')) || 0
      if (user.user_status == 'teach')
      {
      
      }else{
            this.$router.push('/')           
      }
        
    },
        methods: {        
      home() {
        this.$router.push('user')
      },
      logout() {
        localStorage.clear()
        this.$router.push('/')
      }
    }
};
</script>
<style>
.text_google {
  font-family: "Kanit", sans-serif;
}
.v-data-table thead th {
  font-size: 16px !important;
}
</style>
